export default function PrimaryHeading(props) {
  return (
    <>
      <h2 className={`primary-heading transition-all ${props.className ?? ''}`}>
      {props.children}
      </h2>
    </>
  );
}
